import { combineReducers } from 'redux'
import locationReducer from './location'

import questionsReducer from 'store/modules/module_questions.js'
import settingsReducer from 'store/modules/module_settings.js'
import productsReducer from 'store/modules/module_products.js'
import metricsReducer from 'store/modules/module_metrics.js'
import adminReducer from 'store/modules/module_admin.js'
import userReducer from 'store/modules/module_user.js';

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    location: locationReducer,
    questions: questionsReducer,
    settings: settingsReducer,
    products: productsReducer,
    metrics: metricsReducer,
    admin: adminReducer,
    user: userReducer,
    ...asyncReducers
  })
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js